import React from 'react';
import CartProduct from '../cart-product';
import Checkout from '../checkout';
import {connect} from 'react-redux';
import {minusCart , plusCart , deleteCart} from '../../actions';
import './cart.css';




const Cart = ({cart , plusCart , minusCart , deleteCart})=>{


    let data=cart.map((item , index)=>{
        let {id}=item;
        return (
            <CartProduct 
            key={item.name} 
            number={index+1} 
            {...item} 
            clickPlus={()=>plusCart(id)} 
            clickMinus={()=>minusCart(id)} 
            clickDelete={()=>deleteCart(id)}/>
        );
    });
    return(
        <div className="cart">
            <h4 className="cart-title">Your Order</h4>
            <div className="cart-table">
                <div className="cart-table-head">
                    <div className="row">
                        <div className="col-1">
                            <span className="cart-number">#</span>
                        </div>
                        <div className="col-3">
                            <span className="cart-name">Item</span>
                        </div>
                        <div className="col-2">
                            <span className="cart-count">Count</span>
                        </div>
                        <div className="col-2">
                            <span className="cart-price">Price</span>
                        </div>
                        <div className="col-4 d-flex justify-content-end">
                            <span className="cart-action">Action</span>
                        </div>
                    </div>
                </div>
                <div className="cart-table-body">
                   {data}
                </div>
            </div>
        <Checkout/>


        </div>
        
        
    );
}

const mapStateToProps=({cart})=>{
    return{
        cart
    }
}
const mapDispatchToProps={
        deleteCart,
        plusCart,
        minusCart
}

export default connect(mapStateToProps , mapDispatchToProps)(Cart);